export const GET_REPORTS_START_DATE = "GET_REPORTS_START_DATE";
export const SET_REPORTS_START_DATE = "SET_REPORTS_START_DATE";
export const GET_REPORTS_END_DATE = "GET_REPORTS_END_DATE";
export const SET_REPORTS_END_DATE = "SET_REPORTS_END_DATE";